// extracted by mini-css-extract-plugin
module.exports = {"figura":"Jigglypuff_figura__1u8bV","ajuste":"Jigglypuff_ajuste__2jj1G","link":"Jigglypuff_link__1Az3H"};